<ms-market-help *ngIf="showMarketHelp" [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
<div class="option-group-container goal-scorer-container triple">
    <div class="option-group-header">
        <span></span>
        <span *ngFor="let player of players"> {{ player }} </span>
    </div>
    <ng-container *ngFor="let group of optionGroups; trackBy: trackGroup">
        <ng-container *ngTemplateOutlet="optionTemplate; context: { group: group }"></ng-container>
    </ng-container>
</div>

<ng-template #optionTemplate let-group="group">
    <div class="attribute-key">
        <span class="attribute-key-ellipsis">{{ group.attribute }}</span>
    </div>
    <ng-container *ngFor="let option of group.options; trackBy: trackOption">
        <ms-option
            *ngIf="option"
            [tracking]="{ source: tracking }"
            [option]="option"
            [optionGroup]="optionGroup"
            [event]="event"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails"></ms-option>
        <div class="option" *ngIf="!option">
            <div class="offline option-pick"><div class="value">-</div></div>
        </div>
    </ng-container>
</ng-template>
